module.exports = __webpack_public_path__ + "dist/img/dept.54c5a8ad.svg";